const getCollectivityName = (collectivity) => {
    if (collectivity.type_collectivite && 'epci' === collectivity.type_collectivite.code) {
        const { epci: { nom, nature_epci: { libelle } } } = collectivity;

        return `${libelle} ${nom}`;
    }

    return collectivity.commune ? collectivity.commune.nom : '';
};

const getCollectivityNameWithDossier = (collectivity) => `${getCollectivityName(collectivity)} (${collectivity.dossier.nom})`;

export { getCollectivityName, getCollectivityNameWithDossier };



// WEBPACK FOOTER //
// ./src/utils/getCollectivityName.js